export default {
  missingPeriodsLabel: 'Períodos faltantes',
  missingPeriodsDesc: '{count} períodos entre a primeira e a última data desta série não têm dados. Confira se não faltam linhas.',
  shorterThanKpiLabel: 'Mais curta que as vendas',
  shorterThanKpiDesc: 'Esta série começa depois ou termina antes dos dados de vendas. Tudo bem se não houve atividade nesse tempo.',
  outlierLabel: 'Valores incomuns',
  outlierDesc: '{count} períodos estão muito acima ou abaixo do nível habitual desta série. Confira erros de digitação, zeros a mais ou outra unidade.',
  negativeLabel: 'Valores negativos',
  negativeDesc: '{count} linhas têm valores negativos.',
  zerosLabel: 'Vendas zeradas',
  zerosDesc: '{count} períodos têm vendas iguais a zero.',
  allZeroLabel: 'Só zeros',
  allZeroDesc: 'Todos os valores desta série são zero.',
  constantLabel: 'Mesmo valor',
  constantDesc: 'Esta série tem o mesmo valor em todos os períodos. Confira se não é um valor provisório.',
  mixedFrequencyLabel: 'Outra frequência',
  mixedFrequencyDesc: 'Esta série tem uma frequência diferente (por exemplo, mensal em vez de semanal) do resto da aba.',
  weekdayMismatchLabel: 'Datas deslocadas',
  weekdayMismatchDesc: 'Algumas semanas desta série começam em um dia diferente do resto da aba, então parte dos dados pode estar deslocada.',
  repeatedRowsLabel: 'Linhas repetidas',
  repeatedRowsDesc: '{count} linhas repetem a mesma série, data e dimensões, então seus valores são somados.'
}
